import tjSfTemplate from '../components/orders/label_templates/TJ_SF';
import hkZtTemplate from '../components/orders/label_templates/HK_ZT';
import mmZtTemplate from '../components/orders/label_templates/MM_ZT';
import mmSfTemplate from '../components/orders/label_templates/MM_SF';

/**
 * Get the printer ID based on courier and port information
 * @param {string} courier - The courier name
 * @param {string} port - The port name
 * @returns {string} The printer ID to use
 * @throws {Error} If no matching printer is found
 */
// export const getPrinterId = (courier, port) => {
//     if (courier && port) {
//         return port.toLowerCase() + '-' + courier.toLowerCase();
//     }
    
//     throw new Error(`Unsupported courier or port combination (courier: ${courier}, port: ${port})`);
// };

/**
 * Get the appropriate template based on courier service
 * @param {string} courier - The courier name
 * @param {string} port - The port name
 * @returns {Function} The template function to use
 * @throws {Error} If no matching template is found
 */
export const getTemplate = (courier, port) => {
    // const printerId = getPrinterId(courier, port);

    
    switch (courier) {
        case 'tj-sf':
            return tjSfTemplate;
        case 'hk-zt':
            return hkZtTemplate;
        case 'mm-zt':
            return mmZtTemplate;
        case 'mm-sf':
            return mmSfTemplate;
        default:
            throw new Error(`未找到快递模板: (courier: ${courier})`);
    }
};
